import React, { useRef, useState } from "react";
// import SubTopicWisePlatformAnalysisChart from "./SubTopicWisePlatformAnalysisChart";
import { Icon, Dropdown } from "semantic-ui-react";
import html2canvas from "html2canvas";
import { downloadCSVData, downloadCanvasWithTitle, getViewConversationDuration } from "../utils";
import DimmerComponent from "../../DimmerComponent";
// import moment from "moment-timezone";
import { ReactComponent as DownloadIcon } from "../../../../../assets/svg/downloads.svg";
import { ReactComponent as MoreOptions } from "../../../../../assets/svg/menu.svg";
import ChartOptionsSidebar from "../ChartsOptionsSidebar/ChartOptionsSidebar";
import DeleteWidget from "../ChartsOptionsSidebar/DeleteWidget";
import { ReactComponent as CloneIcon } from "../../../../../assets/svg/clone-icon.svg";
import { ReactComponent as Settings } from "../../../../../assets/svg/settings.svg";
import CustomCheckBox from "../ChartsOptionsSidebar/CustomCheckBox";
import NoData from "../NoData/NoData";
import IntervalSelector from "../IntervalSelector";
import { ChartFilterIcon } from "../ChartFilterOptions";
import ChartName from "../ChartName";
import { ReactComponent as MiniMize } from "../../../../../assets/svg/zoom_in_map.svg";
import { ReactComponent as MaxiMize } from "../../../../../assets/svg/zoom_out_map.svg";
import { ReactComponent as Stacked } from "../../../../../assets/svg/stacked.svg";
import Popup from "semantic-ui-react/dist/es/modules/Popup";
import AdvanceCustomChartDisplay from "./AdvanceCustomChartDisplay";
import { advanceEditor, updateViewCount } from "../../../../../actions/dashboardAction";
import { useDispatch, useSelector } from "react-redux";
import { editAdvanceChartConfiguration } from "../../../../../actions/advCustomChartAction";
import moment from "moment/moment";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import { ReactComponent as EditChartIcon } from "../../../../../assets/svg/EditChartIcon.svg";
import { ProductAttributes } from "./../../../Dashboard/ProductAttributeValues";
import { toast } from "react-toastify";
import * as d3 from "d3";
const AdvanceCustomChartHeader = (props) => {
    const chartEl = useRef();
    const dispatch = useDispatch();
    let multiDimensionChartConfig = [];
    multiDimensionChartConfig.push(props.widget.widget_filter.extraArgs.multiDimensionChartConfig);

    const toTitleCase = (str) => {
        return str.replace(/\w\S*/g, function (txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        });
    };
    const viewCountCheckbox = useSelector((state) => state.dashboardReducer.viewCountCheckboxes);

    const handleViewCountCheckbox = (event) => {
        const isChecked = !viewCountCheckbox[props.widget.id]; //
        dispatch(updateViewCount(props.widget.id, isChecked));
    };

    const [downloading, setDownloading] = useState(false);
    const downloadTopicsOverallCSV = () => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }
        // console.log("csv_data0", props.csvData, props);

        if (props?.csvData?.csvData) {
            if (props?.csvData?.csvData?.master_multi_matrix_dimension) {
                // 2Dx2M
                let csvFmt = [];
                let csvData = props?.csvData?.csvData?.data;

                let metAllData0 = csvData[0].data.flatMap((ele) => ele.data).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
                let metAllData1 = csvData[1].data.flatMap((ele) => ele.data).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
                let firstRow = [
                    toTitleCase(`${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.value}`),
                    `${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.breakdownDimensionName.value}`,
                    `${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.metricName.value}`,
                    `${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.breakdownMetricName.value}`,
                ];

                csvFmt.push(firstRow);

                metAllData0.forEach((ele) => {
                    let rowData = [ele.name];
                    rowData.push(ele.breakDownName);
                    rowData.push(ele.y);
                    rowData.push(metAllData1.find((item) => ele.name === item.name && ele.breakDownName === item.breakDownName).y);
                    csvFmt.push(rowData);

                    //Filtering 0,0
                    // const metAllData1Object = metAllData1.find((item) => ele.name === item.name && ele.breakDownName === item.breakDownName);
                    // if (ele.y === 0 && metAllData1Object && metAllData1Object.y !== 0) {
                    //     const rowData = [ele.name, ele.breakDownName, ele.y, metAllData1Object.y];
                    //     csvFmt.push(rowData);
                    // } else if (ele.y !== 0) {
                    //     const rowData = [ele.name, ele.breakDownName, ele.y, metAllData1Object ? metAllData1Object.y : 0];
                    //     csvFmt.push(rowData);
                    // }
                });
                if (
                    props.widget?.widget_filter?.extraArgs?.multiDimensionChartConfig?.dimensionName.label == "published_date" ||
                    props.widget?.widget_filter?.extraArgs?.multiDimensionChartConfig?.breakdownDimensionName.label == "published_date"
                ) {
                    downloadCSVData(csvFmt, props.widget.name.trim());
                } else {
                    const countrySum = {};
                    csvFmt.forEach((item) => {
                        const country = item[0];
                        const value = item[2];
                        countrySum[country] = (countrySum[country] || 0) + value;
                    });

                    // Sort the data based on the sum of the third column for each country
                    const sortedData = csvFmt.sort((a, b) => {
                        const countryA = a[0];
                        const countryB = b[0];
                        const sumA = countrySum[countryA];
                        const sumB = countrySum[countryB];

                        if (sumA - sumB === 0) {
                            return b[2] - a[2];
                        }

                        return sumB - sumA;
                    });

                    downloadCSVData(sortedData, props.widget.name.trim());
                }
            } else if (props?.csvData?.csvData?.master_matrix_dimension) {
                // 1Dx2M
                let csvFmt = [];
                let master_matrix_dimension = props?.csvData?.csvData?.master_matrix_dimension;
                let firstRow = [toTitleCase(`${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.value}`)];
                master_matrix_dimension.forEach((ele, ind) => {
                    firstRow.push(ele);
                });
                let data = props?.csvData?.maximizeData;

                let columns = [firstRow];

                let matrixObject = {};

                for (let axis of [data.leftYAxis, data.rightYAxis]) {
                    let metricName = axis.name;
                    let value = axis.data;
                    for (let val of value) {
                        if (!matrixObject[val.name]) {
                            matrixObject[val.name] = {};
                        }
                        matrixObject[val.name][metricName] = val.y;
                    }
                }

                for (let k of Object.keys(matrixObject)) {
                    columns.push([k, matrixObject[k][columns[0][1]], matrixObject[k][columns[0][2]]]);
                }

                csvFmt = columns;

                downloadCSVData(csvFmt, props.widget.name.trim());
            } else if (props?.csvData?.csvData.master_dimension) {
                // 2Dx1M
                let csvFmt = [];
                let csvData = props?.csvData?.csvData?.data;

                let metAllData0 = csvData.flatMap((ele) => ele.data).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
                // console.log("csvTerrain", metAllData0);

                let firstRow = [
                    toTitleCase(`${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.value}`),
                    `${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.breakdownDimensionName.value}`,
                    `${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.metricName.value}`,
                ];

                csvFmt.push(firstRow);

                metAllData0.forEach((ele) => {
                    let rowData = [ele.name];
                    rowData.push(ele.breakDownName);
                    rowData.push(ele.y);
                    csvFmt.push(rowData);
                });

                if (
                    props.widget?.widget_filter?.extraArgs?.multiDimensionChartConfig?.dimensionName.label == "published_date" ||
                    props.widget?.widget_filter?.extraArgs?.multiDimensionChartConfig?.breakdownDimensionName.label == "published_date"
                ) {
                    downloadCSVData(csvFmt, props.widget.name.trim());
                } else {
                    const countrySum = {};
                    csvFmt.forEach((item) => {
                        const country = item[0];
                        const value = item[2];
                        countrySum[country] = (countrySum[country] || 0) + value;
                    });

                    // Sort the data based on the sum of the third column for each country
                    const sortedData = csvFmt.sort((a, b) => {
                        const countryA = a[0];
                        const countryB = b[0];
                        const sumA = countrySum[countryA];
                        const sumB = countrySum[countryB];

                        if (sumA - sumB === 0 && countryA == countryB) {
                            return b[2] - a[2];
                        }

                        return sumB - sumA;
                    });

                    downloadCSVData(sortedData, props.widget.name.trim());
                }

                // downloadCSVData(csvFmt, props.widget.name.trim());
            } else {
                // 1Dx1M

                let csvFmt = [];
                let csvData = props?.csvData?.csvData;

                let firstRow = [
                    toTitleCase(`${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.value}`),
                    toTitleCase(`${props.widget.widget_filter.extraArgs.multiDimensionChartConfig.metricName.value}`),
                ];

                csvFmt.push(firstRow);
                csvData.forEach((ele, ind) => {
                    let dimension2 = [ele.name];
                    dimension2.push(ele.y);
                    csvFmt.push(dimension2);
                });

                if (props.widget?.widget_filter?.extraArgs?.multiDimensionChartConfig?.dimensionName.label == "published_date") {
                    downloadCSVData(csvFmt, props.widget.name.trim());
                } else {
                    csvFmt = csvFmt.sort((a, b) => b[1] - a[1]);

                    downloadCSVData(csvFmt, props.widget.name.trim());
                }
            }
        } else {
            toast.error("Something went wrong.");
        }
    };

    const renderDownloadButton = (nodata) => {
        return (
            <Dropdown
                disabled={nodata}
                trigger={
                    <div className="chart-header-icon">
                        <DownloadIcon className="chart-download-icon" />
                    </div>
                }
                icon={null}
                className="chart-download-dropdown hideable"
                direction="left">
                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => downloadTopicsOverallCSV()}>CSV</Dropdown.Item>
                    <Dropdown.Item onClick={() => downloadPNG(true)}>PNG</Dropdown.Item>
                    <Dropdown.Item onClick={() => downloadPNG(false)}>PNG(Transparent)</Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
        );
    };

    const downloadPNG = (options) => {
        if (props.isFreeTierPackage) {
            props.packageUpgradePopup();
            return;
        }
        setDownloading(true);
        return html2canvas(chartEl.current, { backgroundColor: options ? "#fff" : null }).then((canvas) => {
            setDownloading(false);
            downloadCanvasWithTitle(canvas, props.widget.name.trim());
        });
    };

    const editAdvanceModal = async (multiDimensionChartConfig) => {
        const widgetId = props.widget.id;
        const widgetName = props.widget.name;
        multiDimensionChartConfig["widgetId"] = widgetId;
        multiDimensionChartConfig["widgetName"] = widgetName;
        // let topTopicsSubtopics = [...topTenSubTopics, ...topTenTopics];
        // if (topTopicsSubtopics?.length === 0) {
        //     if (["topics_data", "sub_topics_data"].includes(multiDimensionChartConfig[0]?.dimensionName)) await dispatch(getTopTenTopicicsByDataUsage());
        //     else dispatch(getTopTenTopicicsByDataUsage());
        // }
        dispatch(advanceEditor(true));
        dispatch(editAdvanceChartConfiguration(multiDimensionChartConfig));
    };

    const addContextMenuListener = (x, y, chart) => {
        if (props.isPublic) return;
        let self = this;
        let contextMenu = d3.select(".dashboard-charts-contextmenu");

        contextMenu.attr("data-type", "clickedMenu");
        contextMenu.style("top", `${y + 10}px`);
        contextMenu.style("left", `${x - 82}px`);
        contextMenu.style("background", `#fff`);
        contextMenu.style("zIndex", `${99999999}`);
        contextMenu.style("color", `#1a1a1a`);
        contextMenu.html(null);
        contextMenu
            .append("li")
            .text("View Conversations")
            .on("click", () => {
                handleContextMenuClick(chart);
            });
        contextMenu
            .append("li")
            .text("View Insights")
            .on("click", () => {
                handleDrilldownClick(chart);
                // props.showChartsDrilldown(true, "moments");
            });
        contextMenu.style("display", "block");
    };

    const handleContextMenuClick = (chart) => {
        let newFilter = createNewFilter(chart);
        props.handleContextMenuClick(newFilter);
    };

    const handleDrilldownClick = (d) => {
        let newFilter = createNewFilter(d);
        props.handleDrilldownClick(newFilter);
    };

    const createNewFilter = (chart) => {
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        const dimensionNameObj = {
            platforms: "Platforms",
            countries: "Countries",
            languages: "Languages",
            sub_topics_data: "Sub Topics",
            topics_data: "Topics",
        };
        const post_types_names = {
            0: "Only Post",
            1: "Comment/ Replies",
            2: "Retweet",
            3: "LexisNexis Online Post",
            4: "LexisNexis Offline Post",
            5: "Quoted Retweet",
        };

        let newFilter = props.filters ? JSON.parse(JSON.stringify(props.filters)) : {};

        if (chart.options.name == "Others") {
            if (chart.options.dimensionName == "sub_topics_data") {
                newFilter.subtopics = chart.options.dataId;
                newFilter.topics = [];
            } else if (chart.options.dimensionName == "topics_data") {
                newFilter.topics = chart.options.dataId;
                newFilter.subtopics = [];
            } else if (chart.options.dimensionName == "product_attributes") {
                // let prodObject = ProductAttributes.data.filter((ele) => ele.attributeName === chart.options.dataId);

                newFilter.extras = [{ key: "size", value: 1 }];
                // newFilter.product_attribute_categories = chart.options.name;
                // newFilter.entitySubType = "";
            } else if (chart.options.dimensionName == "wordclouds") {
                let result;

                if (chart.options.dataId.length > 1) {
                    result = chart.options.dataId.join(",");
                } else {
                    result = chart.options.dataId;
                }

                newFilter.extras = [{ key: "Drilled Down Words", value: [result] }];
                if (props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.value === "Top Positive Keyword") {
                    newFilter.extras.push({ key: "Sentiment", value: "positive" });
                } else if (props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.value === "Top Negative Keyword") {
                    newFilter.extras.push({ key: "Sentiment", value: "negative" });
                }
            } else if (chart.options.dimensionName == "moments") {
                let tag_category_ids = chart.options.dataId;
                newFilter.tag_category_ids = "" + tag_category_ids;
            } else if (chart.options.dimensionName == "published_date") {
                newFilter.duration = "custom";
                newFilter.startDateTime = chart.options.dataId;
                newFilter.endDateTime = moment(chart.options.name).endOf("day").format("YYYY-MM-DD HH:mm:ss");
            } else {
                newFilter[chart.options.dimensionName] = chart.options.dataId;
            }

            if (!newFilter.extras) {
                newFilter.extras = [];
            }

            if (chart.options.breakdownDimensionName == "product_attributes" || chart.options.breakdownDimensionName == "Product Attributes") {
                let prodObject = ProductAttributes.data.filter((ele) => ele.attributeName === chart.options.breakDownName);
                newFilter.product_attribute_categories = [prodObject[0].categoryName];
                // newFilter.product_attribute_categories = chart.options.breakDownId;
                // newFilter.entitySubType = "";
            } else if (chart.options.breakdownDimensionName == "wordclouds" || chart.options.breakdownDimensionName == "Top Keywords") {
                newFilter.extras = [{ key: "Drilled Down Words", value: chart.options.breakDownId }];
                if (props.widget.widget_filter.extraArgs.multiDimensionChartConfig.breakdownDimensionName.value === "Top Positive Keyword") {
                    newFilter.extras.push({ key: "Sentiment", value: "positive" });
                } else if (props.widget.widget_filter.extraArgs.multiDimensionChartConfig.breakdownDimensionName.value === "Top Negative Keyword") {
                    newFilter.extras.push({ key: "Sentiment", value: "negative" });
                }
            } else if (chart.options.breakdownDimensionName == "sentiments" || chart.options.breakdownDimensionName == "Sentiments") {
                newFilter.extras = [...newFilter.extras, { key: "Sentiment", value: chart.options.breakDownId[0].toLowerCase() }];
            } else if (chart.options.breakdownDimensionName == "published_date" || chart.options.breakdownDimensionName == "Published Date") {
                newFilter.duration = "custom";
                newFilter.startDateTime = chart.options.breakDownId[0];
                newFilter.endDateTime = moment(chart.options.breakDownId[0]).endOf("day").format("YYYY-MM-DD HH:mm:ss");
                // newFilter.extras = [{ key: "published_date", value: chart.options.breakDownId.toLowerCase() }];
                // newFilter[chart.options.breakdownDimensionName] = [chart.options.breakDownId];
            } else if (chart.options.breakdownDimensionName == "post_types" || chart.options.breakdownDimensionName == "Post Types") {
                const postTypeId = Object.keys(post_types_names).find((key) => post_types_names[key] === chart.options.breakDownId[0]);
                newFilter.extras = [...newFilter.extras, { key: "post_type", value: postTypeId }];
            } else if (chart.options.breakdownDimensionName == "entity_types" || chart.options.breakdownDimensionName == "Entity Types") {
                newFilter.entityType = chart.options.breakDownId[0];
                if (chart.options.breakDownId[0].toLowerCase() === "person") {
                    newFilter.entitySubType = "male,female";
                }
            } else if (chart.options.breakdownDimensionName == "entity_sub_type" || chart.options.breakdownDimensionName == "Entity SubType") {
                if (chart.options.breakDownId[0] == "News" || chart.options.breakDownId[0] == "Brand") {
                    newFilter.entityType = "non-person";
                    newFilter.entitySubType = chart.options.breakDownId[0].toLowerCase();
                } else if (chart.options.breakDownId[0] == "Male" || chart.options.breakDownId[0] == "Female") {
                    newFilter.entityType = "person";
                    newFilter.entitySubType = chart.options.breakDownId[0].toLowerCase();
                } else {
                    newFilter.entityType = chart.options.breakDownId[0].toLowerCase();
                    newFilter.entitySubType = "";
                }
                // newFilter.entitySubType = chart.options.breakDownId;
            } else if (chart.options.breakdownDimensionName == "moments" || chart.options.breakdownDimensionName == "Moments") {
                let tag_category_ids = chart.options.breakDownId;
                newFilter.tag_category_ids = "" + tag_category_ids;
            } else {
                const chartBreakdownDimensionName = Object.keys(dimensionNameObj).find((key) => dimensionNameObj[key] === chart.options.breakdownDimensionName);
                if (chartBreakdownDimensionName) {
                    newFilter[chartBreakdownDimensionName] = chart.options.breakDownId;
                } else {
                    newFilter[chart.options.breakdownDimensionName] = chart.options.breakDownId;
                }
            }
        } else {
            if (chart.options.dimensionName == "sentiments") {
                newFilter.extras = [{ key: "Sentiment", value: chart.options.name.toLowerCase() }];
            } else if (chart.options.dimensionName == "published_date") {
                newFilter.duration = "custom";
                newFilter.startDateTime = chart.options.dataId;
                newFilter.endDateTime = moment(chart.options.name).endOf("day").format("YYYY-MM-DD HH:mm:ss");
                // newFilter.extras = [{ key: "Aggs Interval", value: "day" }];
                // newFilter.extras = [{ key: "Aggs_Interval", value: "day" }];

                // newFilter.extras = [{ key: "published_date", value: chart.options.name.toLowerCase() }];
                // newFilter[chart.options.dimensionName] = [chart.options.name];
            } else if (chart.options.dimensionName == "post_types") {
                if (typeof chart.options.dataId === "string") {
                    const postTypeId = Object.keys(post_types_names).find((key) => post_types_names[key] === chart.options.dataId);

                    newFilter.extras = [{ key: "post_type", value: `${postTypeId}` }];
                } else {
                    newFilter.extras = [{ key: "post_type", value: `${chart.options.dataId}` }];
                }
                // newFilter.extras = [{ key: "post_type", value: `${chart.options.dataId}` }];
            } else if (chart.options.dimensionName == "entity_types") {
                newFilter.entityType = chart.options.name.toLowerCase();
                if (chart.options.name.toLowerCase() === "person") {
                    newFilter.entitySubType = "male,female";
                }
            } else if (chart.options.dimensionName == "entity_sub_type") {
                if (chart.options.name == "News" || chart.options.name == "Brand") {
                    newFilter.entityType = "non-person";
                    newFilter.entitySubType = chart.options.name.toLowerCase();
                } else if (chart.options.name == "Male" || chart.options.name == "Female") {
                    newFilter.entityType = "person";
                    newFilter.entitySubType = chart.options.name.toLowerCase();
                } else {
                    newFilter.entityType = chart.options.name.toLowerCase();
                    newFilter.entitySubType = "";
                }
            } else if (chart.options.dimensionName == "sub_topics_data") {
                newFilter.subtopics = [chart.options.dataId];
                newFilter.topics = [];
            } else if (chart.options.dimensionName == "topics_data") {
                newFilter.topics = [chart.options.dataId];
                newFilter.subtopics = [];
            } else if (chart.options.dimensionName == "product_attributes") {
                let prodObject = ProductAttributes.data.filter((ele) => ele.attributeName === chart.options.name);
                newFilter.product_attribute_categories = [prodObject[0].categoryName];
                newFilter.extras = [{ key: "size", value: 1 }];
                // newFilter.product_attribute_categories = [chart.options.name];
                // newFilter.entitySubType = "";
            } else if (chart.options.dimensionName == "wordclouds") {
                newFilter.extras = [{ key: "Drilled Down Words", value: [chart.options.dataId] }];
                // newFilter.extras = [{ key: "Drilled Down Words", value: [chart.options.name.toLowerCase()] }];
                if (props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.value === "Top Positive Keyword") {
                    newFilter.extras.push({ key: "Sentiment", value: "positive" });
                } else if (props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.value === "Top Negative Keyword") {
                    newFilter.extras.push({ key: "Sentiment", value: "negative" });
                }
            } else if (chart.options.dimensionName == "moments") {
                let tag_category_ids = chart.options.dataId;
                newFilter.tag_category_ids = "" + tag_category_ids;
            } else if (chart.options.dimensionName == "top_influencers") {
                newFilter.extras = [{ key: "User", value: chart.options.dataId }];
            }
            // newFilter.extras = [{ key: "Drilled Down Words", value: [cluster_keyword.toLowerCase()] }]
            else {
                newFilter[chart.options.dimensionName] = [chart.options.dataId];
            }

            if (!newFilter.extras) {
                newFilter.extras = [];
            }

            if (chart.options.breakdownDimensionName == "sentiments" || chart.options.breakdownDimensionName == "Sentiments") {
                newFilter.extras = [...newFilter.extras, { key: "Sentiment", value: chart.options.breakDownId.toLowerCase() }];
            } else if (chart.options.breakdownDimensionName == "published_date" || chart.options.breakdownDimensionName == "Published Date") {
                newFilter.duration = "custom";
                newFilter.startDateTime = chart.options.breakDownId;
                newFilter.endDateTime = moment(chart.options.breakDownId).endOf("day").format("YYYY-MM-DD HH:mm:ss");
                // newFilter.extras = [...newFilter.extras, { key: "Aggs_Interval", value: "day" }];/

                // newFilter.extras = [{ key: "published_date", value: chart.options.breakDownId.toLowerCase() }];
                // newFilter[chart.options.breakdownDimensionName] = [chart.options.breakDownId];
            } else if (chart.options.breakdownDimensionName == "post_types" || chart.options.breakdownDimensionName == "Post Types") {
                if (typeof chart.options.breakDownId === "string" && chart.options.breakDownId.length > 1) {
                    const postTypeId = Object.keys(post_types_names).find((key) => post_types_names[key] === chart.options.breakDownId);
                    newFilter.extras = [...newFilter.extras, { key: "post_type", value: `${postTypeId}` }];
                } else {
                    newFilter.extras = [...newFilter.extras, { key: "post_type", value: `${chart.options.breakDownId}` }];
                }
            } else if (chart.options.breakdownDimensionName == "entity_types" || chart.options.breakdownDimensionName == "Entity Types") {
                newFilter.entityType = chart.options.breakDownId.toLowerCase();
                if (chart.options.breakDownId.toLowerCase() === "person") {
                    newFilter.entitySubType = "male,female";
                }
            } else if (chart.options.breakdownDimensionName == "entity_sub_type" || chart.options.breakdownDimensionName == "Entity SubType") {
                if (
                    chart.options.breakDownId == "News" ||
                    chart.options.breakDownId == "news" ||
                    chart.options.breakDownId == "Brand" ||
                    chart.options.breakDownId == "brand"
                ) {
                    newFilter.entityType = "non-person";
                    newFilter.entitySubType = chart.options.breakDownId.toLowerCase();
                } else if (
                    chart.options.breakDownId == "Male" ||
                    chart.options.breakDownId == "male" ||
                    chart.options.breakDownId == "Female" ||
                    chart.options.breakDownId == "female"
                ) {
                    newFilter.entityType = "person";
                    newFilter.entitySubType = chart.options.breakDownId.toLowerCase();
                } else {
                    newFilter.entityType = chart.options.breakDownId.toLowerCase();
                    newFilter.entitySubType = "";
                }
                // newFilter.entitySubType = chart.options.breakDownId;
            } else if (chart.options.breakdownDimensionName == "wordclouds" || chart.options.breakdownDimensionName == "Top Keywords") {
                newFilter.extras = [...newFilter.extras, { key: "Drilled Down Words", value: [chart.options.breakDownId] }];
                // newFilter.extras = [...newFilter.extras, { key: "Drilled Down Words", value: [chart.options.breakDownId.toLowerCase()] }];
                if (props.widget.widget_filter.extraArgs.multiDimensionChartConfig.breakdownDimensionName.value === "Top Positive Keyword") {
                    newFilter.extras.push({ key: "Sentiment", value: "positive" });
                } else if (props.widget.widget_filter.extraArgs.multiDimensionChartConfig.breakdownDimensionName.value === "Top Negative Keyword") {
                    newFilter.extras.push({ key: "Sentiment", value: "negative" });
                }
            } else if (chart.options.breakdownDimensionName == "product_attributes" || chart.options.breakdownDimensionName == "Product Attributes") {
                let prodObject = ProductAttributes.data.filter((ele) => ele.attributeName === chart.options.breakDownName);

                newFilter.product_attribute_categories = [prodObject[0].categoryName];
                // newFilter.product_attribute_categories = [chart.options.breakDownId];
            } else if (chart.options.breakdownDimensionName == "top_influencers" || chart.options.breakdownDimensionName == "Top Influencers") {
                newFilter.extras = [...newFilter.extras, { key: "User", value: chart.options.breakDownId }];
            } else if (chart.options.breakdownDimensionName == "moments" || chart.options.breakdownDimensionName == "Moments") {
                let tag_category_ids = chart.options.breakDownId;
                newFilter.tag_category_ids = "" + tag_category_ids;
            } else if (chart.options.breakdownDimensionName) {
                const chartBreakdownDimensionName = Object.keys(dimensionNameObj).find((key) => dimensionNameObj[key] === chart.options.breakdownDimensionName);
                if (chartBreakdownDimensionName) {
                    newFilter[chartBreakdownDimensionName] = [chart.options.breakDownId];
                } else {
                    newFilter[chart.options.breakdownDimensionName] = [chart.options.breakDownId];
                }
            }
        }

        if (chart.options.yAxisName == "Like Count" || chart.options.metricName == "like_count") newFilter.orderBy = "post.engagement_values.like_count";
        else if (chart.options.yAxisName == "Comment Count" || chart.options.metricName == "comment_count")
            newFilter.orderBy = "post.engagement_values.comment_count";
        else if (chart.options.yAxisName == "Share Count" || chart.options.metricName == "share_count")
            newFilter.orderBy = "post.engagement_values.share_count";
        else if (chart.options.yAxisName == "View Count" || chart.options.metricName == "view_count") newFilter.orderBy = "post.engagement_values.view_count";
        else if (chart.options.yAxisName == "Impact Value" || chart.options.metricName == "impact_value") newFilter.orderBy = "impact_value";
        else if (chart.options.yAxisName == "Engagement Value" || chart.options.metricName == "enagagment_value") newFilter.orderBy = "impact_value";
        else if (chart.options.yAxisName == "Estimated Reach" || chart.options.metricName == "estimated_reach") newFilter.orderBy = "estimated_reach";

        // if (chart.options.breakdownDimensionName) {
        //     newFilter[chart.options.breakdownDimensionName] = [chart.options.breakDownId];
        // }
        //newFilter.extras = [{ key: "post_media_type", value: chart.mediaType }];
        // newFilter.extras = [{ key: "Sentiment", value: chart.sentiment }];
        if (chart.options.dimensionName == "published_date") {
            let lastComparisonIndex = false;
            newFilter = getViewConversationDuration(
                chart,
                newFilter,
                props.aggs_val,
                props.filters,
                props.comparisionData,
                lastComparisonIndex,
                props.comparisonAppliedFilter,
            );
            if (props.appliedFilter.duration === "custom" && !props.appliedFilter.rollingDate) {
                let customEndDate = moment(props.appliedFilter.end_date);
                let newEndDate = moment(newFilter.endDateTime).tz(tz);
                if (newEndDate.isAfter(customEndDate)) {
                    newEndDate.set(customEndDate.toObject());

                    newFilter.endDateTime = newEndDate.tz(tz).format("YYYY-MM-DDTHH:mm:ss");
                }
            }
        }

        return newFilter;
    };

    let nodata =
        !props.data ||
        (props.data && props.data?.length === 0) ||
        (props.data && props.data.nodata) ||
        props.noTopicsSelected ||
        props.onlyYtPlatformSelected ||
        ((props.graph_type == "line" || props.graph_type == "stacked") && props.csvData?.lineData?.[0]?.nodata);
    // (props.csvData?.data?.leftYAxis?.lineData?.length == 0 && props.csvData?.data?.rightYAxis?.lineData?.length)));
    // let noTopicsSubtopicsSelected =
    //     [...props.widget?.widget_filter?.query?.filters?.topics, ...props.widget?.widget_filter?.query?.filters?.subtopics]?.length === 0;
    // let showNoData =
    //     ["sub_topics_data", "topics_data"].includes(props.widget?.widget_filter?.extraArgs?.multiDimensionChartConfig?.dimensionName?.label) &&
    //     noTopicsSubtopicsSelected;
    let breakdownDimensionName = props.widget.widget_filter.extraArgs.multiDimensionChartConfig.breakdownDimensionName;
    let dimensionNameValue = props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName;
    let infoMessage =
        breakdownDimensionName.label == "top_influencers" || dimensionNameValue.label == "top_influencers"
            ? "We are showing top influencers metrics data based on impact score."
            : breakdownDimensionName.label == "wordclouds" || dimensionNameValue.label == "wordclouds"
            ? "Word cloud , Top positive , Top negative , Top influencer view conversation will not match exactly "
            : "Allows you to see a breakdown of platforms based on conversation volumes.";

    return (
        <>
            <div className="dashboard-widget-container-header skiptranslate">
                <ChartName
                    name={props.widget.name}
                    advanceChart
                    info={`How to use a chart 
Just drag and drop dimensions and metrics on the chart or add them using the +icon Save the chart when done and it will be saved and added to the dashboard
Dimensions
These are variables that can be plotted on X-Axis.  You can select 1 or 2 dimensions to be plotted on the X-Axis. Examples include Platform, Country, Top Keywords etc.
Please note that dimensions related to keywords can only be plotted in Dimension 2 if another dimension has also been selected.
Metrics
These are values that are plotted on the Y-Axis.  You can select 1 or 2 metrics to be plotted on the Y-Axis.  Examples include Volume of Conversations, Engagement etc.
Limitations
Some of the dimensions use sampling for faster performance due to the enormous volume of data that needs to be processed to plot the charts.
There may be minor (statistically insignificant) discrepancy in those charts. These dimensions include keyword dimensions as well as top influencers.
Influencers data is calculated using the impact created by influencers.
`}
                />
                <div className="dashboard-widget-actions" data-html2canvas-ignore="true">
                    {!nodata && props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.label == "published_date" && (
                        <div className="chart-type">
                            <span onClick={() => props.changeGraphType("line")} className={props.graph_type === "line" ? "active-chart" : ""}>
                                <Icon name="line chart" />
                            </span>
                            <span onClick={() => props.changeGraphType("stacked")} className={props.graph_type === "stacked" ? "active-chart" : ""}>
                                <Stacked name="line chart" />
                            </span>
                        </div>
                    )}
                    {!props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <Popup
                                className="skiptranslate"
                                trigger={
                                    <EditChartIcon
                                        className="chart-header-icon"
                                        widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                        name={props.widget.name}
                                        onClick={() => editAdvanceModal(multiDimensionChartConfig)}
                                    />
                                }
                                inverted
                                content={"Edit Chart Configuration"}
                                size="mini"
                                position="bottom center"
                                style={{ zIndex: "99999" }}
                            />
                        )}

                    {!props.isPublic &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <ChartFilterIcon
                                chartFilterApplied={props.chartFilterApplied}
                                changeShowChartFilterOptions={props.changeChartFilter}
                                widgetListDashboardCurrent={props.widgetListDashboardCurrent}
                                name={props.widget.name}
                            />
                        )}
                    {!props.isPublic && !props.isResearchDashboard && <>{renderDownloadButton(nodata)}</>}
                    {
                        <>
                            {props.isPublic && nodata ? null : (
                                <Popup
                                    className="skiptranslate"
                                    trigger={
                                        props.expandWidget ? (
                                            <MiniMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        ) : (
                                            <MaxiMize className="chart-header-icon" onClick={props.expandFullWidget} />
                                        )
                                    }
                                    inverted
                                    content={props.expandWidget ? "Minimize Widget" : "Maximize Widget"}
                                    size="mini"
                                    position="bottom center"
                                    style={{ zIndex: "99999" }}
                                />
                            )}
                        </>
                    }
                    {props.isPublic && nodata ? null : <MoreOptions className="more-options" onClick={(e) => props.changeShowMoreOptions(e)} />}
                </div>
            </div>
            {props.showMoreOptions && (
                <ChartOptionsSidebar
                    data-html2canvas-ignore="true"
                    showMoreOptionsLoc={props.showMoreOptionsLoc}
                    changeShowMoreOptions={props.changeShowMoreOptions}>
                    {!nodata &&
                        (props.widget.widget_filter.extraArgs.multiDimensionChartConfig?.metricName.label === "enagagment_value" ||
                            props.widget.widget_filter.extraArgs.multiDimensionChartConfig?.breakdownMetricName.label === "enagagment_value") && (
                            <CustomCheckBox onClick={handleViewCountCheckbox} checked={viewCountCheckbox[props.widget.id]} label="Exclude View Count" />
                        )}
                    {!nodata && props.graph_type !== "line" && <CustomCheckBox checked={props.hideLabel} onClick={props.changeHideLable} label="Show Labels" />}
                    {!nodata && <CustomCheckBox checked={props.showLegendBar} onClick={props.changeShowLegendBar} label="Show Legends" />}
                    {!nodata && <CustomCheckBox label="Show Grid Lines" checked={props.showGridLines} onClick={props.changeShowGridLines} />}
                    {/* {!nodata && props.graph_type === "line" && (
                        <IntervalSelector
                            appliedFilter={props.appliedFilter}
                            handleIntervalChange={props.handleIntervalChange}
                            disableComparisonInterval={props.disableComparisonInterval}
                        />
                    )} */}
                    {props.widget.widget_filter.extraArgs.multiDimensionChartConfig?.dimensionName.label == "published_date" && (
                        <IntervalSelector
                            aggs_val={props.aggs_val}
                            appliedFilter={props.appliedFilter}
                            handleIntervalChange={props.handleIntervalChange}
                            disableComparisonInterval={props.disableComparisonInterval}
                            removeInterval={true}
                        />
                    )}

                    {!props.isPublic &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && (
                            <>
                                {/* <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                    <span>Chart Configuration</span>
                                    <Settings
                                     />
                                </div> */}
                                {props.widget.widget_filter.extraArgs.multiDimensionChartConfig.dimensionName.label == "published_date" && (
                                    <div className="chart-settings menu-option" onClick={props.chartSettings}>
                                        <span>Chart Configuration</span>
                                        <Settings />
                                    </div>
                                )}
                                <div className="clone-chart menu-option" onClick={props.cloneWidget}>
                                    <span>Clone Chart</span>
                                    <CloneIcon />
                                </div>
                            </>
                        )}
                    {!props.isPublic &&
                        !props.isStandardDashboard &&
                        !props.isResearchDashboard &&
                        props.dashboardPageType !== "temporaryInsights" &&
                        props.dashboardPageType !== "temporary" && <DeleteWidget onClick={props.deleteWidget} />}
                </ChartOptionsSidebar>
            )}
            {!nodata ? (
                <div className="dashboard-chart skiptranslate" ref={chartEl}>
                    <AdvanceCustomChartDisplay
                        data={props.data}
                        // advCustomChartReducer={props.advCustomChartReducer}
                        csvData={props.csvData}
                        maximizeData={props.csvData?.maximizeData}
                        widgetContainerRef={props.widgetContainerRef}
                        showLabel={props.hideLabel}
                        showLegend={props.showLegendBar}
                        showGridLines={props.showGridLines}
                        resizedCount={props.resizedCount}
                        expandWidget={props.expandWidget}
                        widget={props.widget?.widget_filter?.extraArgs}
                        addContextMenuListener={addContextMenuListener}
                        currentChartType={props.graph_type}
                    />
                    {downloading && <DimmerComponent />}
                </div>
            ) : props.advanceWidgetDashboardDataLoading ? (
                <Dimmer inverted active>
                    <Loader size="big skiptranslate"></Loader>
                </Dimmer>
            ) : (
                <NoData
                    message={
                        !props.isPublic && props.noTopicsSelected
                            ? "To view charts, please select topics using either the page filters on the left or the chart filters on this chart."
                            : null
                    }
                    // message={!props.isPublic && props.noTopicsSelected ? "To view charts, please select topics using the chart filters on this chart." : null}
                />
            )}
        </>
    );
};

export default AdvanceCustomChartHeader;
